var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1100 127L1100 155",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100.5,
    cy: 122.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.99 122.19C1095.99 118.283 1099.29 115.117 1103.36 115.117C1103.94 115.117 1104.51 115.184 1105.06 115.308C1103.74 114.48 1102.19 114 1100.52 114C1095.81 114 1092 117.806 1092 122.5C1092 127.194 1095.81 131 1100.52 131C1102.81 131 1104.89 130.093 1106.43 128.62C1105.49 129.032 1104.45 129.263 1103.36 129.263C1099.29 129.263 1095.99 126.096 1095.99 122.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.4 121.6L1109.37 119.146L1107.54 120.719L1105.3 120.056L1106.11 122.337L1104.77 124.381L1107.1 124.218L1108.5 126.144L1109.13 123.763L1111.34 122.909L1109.4 121.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.8ebb2c592b7d323d7656c87c6868373c.svg";
export { ForwardRef as ReactComponent };